const checkEquality = (a, b) => JSON.stringify(a) === JSON.stringify(b)

export interface HandlerItem {
    fn(a: any, b: any, state: Ref<any>)
    eventName: 'default' | 'flushOnChange' | 'flushOnEmpty' 
}

export function useWatcher(fields: string[]) {
    const handlers: HandlerItem[] = []
    let ignores: string[] = []
    let previousState = {}
    const instance = {
        handlers,
        fields,
        addHandler: (
            eventName: HandlerItem['eventName'], 
            fn: HandlerItem['fn']
        ) => {
            handlers.push({ eventName, fn })
        },
        bindState: (state: Ref<any>) => {
            watch(() => {
                const s = state.value
                return fields.reduce((acc, key) => {
                    acc[key] = s[key]
                    return acc
                } , {})
            }, (currentState) => {
                if (!checkEquality(previousState, currentState)) {
                    const filteredHandlers = handlers
                        .filter(handler => !ignores.includes(handler.eventName))
                    console.log(`Executing ${filteredHandlers.length}/${handlers.length} handlers. Ignoring: ${JSON.stringify(ignores)}`)
                    filteredHandlers.forEach(handler => handler.fn(currentState, previousState, state))
                }
                previousState = currentState
            })
        },
        ignoreAndRun(ignoreEvents: HandlerItem['eventName'][], fn: any) {
            ignores = ignoreEvents
            nextTick(() => fn())
            setTimeout(() => {
                // fn()
                nextTick(() => ignores = [])
            }, 500)
        },
    }
    
    return instance
}